"use client";
import { AuthProvider } from "@/context/auth-context";
import "@/styles/globals.css";
import Footer from "@/components/Footer";
import { PHProvider } from "./providers";
import { useRef, useState } from "react";
import { ModalContext } from "@/context/price-modal-context";
import PriceCollection from "@/components/PriceCollection";
import { OrderProvider } from "@/context/order-context";

export default function SubLayout({ children }: { children: React.ReactNode }) {
  "use client";
  const modalRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => {
    setIsModalOpen(true);
    (modalRef as any).current.showModal();
  };

  const closeModal = () => {
    setIsModalOpen(false);
    (modalRef as any).current.close();
  };

  const modalContextValue = {
    openModal,
    closeModal,
  };

  return (
    <PHProvider>
      <AuthProvider>
        <OrderProvider>
          <ModalContext.Provider value={modalContextValue}>
            {children}
            <Footer />
            <dialog
              id="my_modal_1"
              className="modal"
              ref={modalRef}
              onClose={closeModal}
            >
              <div className="modal-box">
                {isModalOpen && <PriceCollection />}
              </div>
            </dialog>
          </ModalContext.Provider>
        </OrderProvider>
      </AuthProvider>
    </PHProvider>
  );
}
